import SocketIO from 'src/backend/SocketIO';

// Tell the backend a donation changed; it works out which teams to notify.
export default function emitDonationUpdate({
  donationId = null,
  patternId = null,
  teamId,
  isFoodRun = false,
}) {
  SocketIO.getIO().emit('DONATION-UPDATE', {
    donationId,
    patternId,
    teamId,
    type: isFoodRun ? 'FOOD-RUN' : 'DONATION',
  });
}
